<div class="heading-elements">
  <button
    class="btn round btn-outline-info"
    data-toggle="modal"
    style="width: 100px"
    data-target="#modalDollarRateForm"
    >
    Edit
    <i class="fa fa-pencil" aria-hidden="true"></i>
  </button>
  <div
    class="modal fade"
    id="modalDollarRateForm"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header text-center">
          <h4 class="modal-title w-200 font-weight-bold">Edit Dollar Rate</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            id="closeModal"
            >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form [formGroup]="form" (ngSubmit)="editRate()">
          <div class="modal-body mx-3">
            <div class="md-form mb-1">
              <div class="form-group row">
                <label for="named" class="col-sm-4 col-form-label"
                  >Exchange Rate(₦)</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="number"
                      formControlName="rate"
                      class="form-control round"
                      name="rate"
                      id="rate"
                      />
                  </div>
                  @if (rate.touched && rate.invalid) {
                    <div
                      class="alert alert-danger error"
                      >
                      @if (rate.errors.required) {
                        <div>Rate is required</div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="modal-footer d-flex justify-content-center">
              <button
                class="btn btn-success btn-round pl-30 pr-30"
                [disabled]="form.invalid || clicked === true"
                >
                Edit</button
                >@if (clicked === true) {
                <i class="icons icon-loading"></i>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
